import type { SearchQueryBody } from "@/types";

/**
 * Query key factory for file queries. Mirrors `eventQueryKeys` /
 * `datasetQueryKeys` so list reads and any future mutation invalidations
 * stay aligned across entities.
 */
export const fileQueryKeys = {
  all: ["files"] as const,
  lists: () => [...fileQueryKeys.all, "list"] as const,
  list: (orgId: string | undefined, query?: SearchQueryBody) =>
    query
      ? ([...fileQueryKeys.lists(), orgId, query] as const)
      : ([...fileQueryKeys.lists(), orgId] as const),
};
